import { useState, useEffect } from "react";

/**
 * Hook to calculate remaining minutes until next auto-refresh
 * @param dataUpdatedAt - Timestamp of last data update (from React Query)
 * @param refreshIntervalMinutes - Number of minutes between refreshes
 * @param enabled - Whether auto-refresh is enabled
 * @returns Number of minutes remaining until next refresh
 */
export const useRefreshCountdown = (
  dataUpdatedAt: number | undefined,
  refreshIntervalMinutes: number,
  enabled: boolean
): number => {
  const [minutesRemaining, setMinutesRemaining] = useState(
    refreshIntervalMinutes
  );

  useEffect(() => {
    if (!enabled || !dataUpdatedAt) {
      setMinutesRemaining(refreshIntervalMinutes);
      return;
    }

    const updateCountdown = () => {
      const elapsedMs = Date.now() - dataUpdatedAt;
      const elapsedMinutes = Math.floor(elapsedMs / 60000);
      const remaining = Math.max(0, refreshIntervalMinutes - elapsedMinutes);
      setMinutesRemaining(remaining);
    };

    updateCountdown();
    const interval = setInterval(updateCountdown, 60000);

    return () => clearInterval(interval);
  }, [dataUpdatedAt, refreshIntervalMinutes, enabled]);

  return minutesRemaining;
};
